// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Zk5U","list":"styles_list__2TFSt","disableSelection":"styles_disableSelection__2IYB2"};